import { ApiClient } from '@webapp/core/services/ApiClient'
import { createLocalStorage } from '@webapp/core/services/LocalPersistentStorage'
import { UserRepository } from '@webapp/platform/iam/data-access/repositories/UserRepository/UserRepository'

export const userRepository = new UserRepository({
  httpClient: ApiClient,
  persistentStorage: createLocalStorage(),
})
